import { CONTACT_DETAILS } from 'constant/output/contact-details'

export const CONTACT_DETAILS_KEY = CONTACT_DETAILS.map(contact => contact.key)

export const ENCRYPTION_KEY = 'VERIFY_ENCRYPTION_KEY'